import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";

export default function EmptyAdditionalCharges({ description, onAddBillingCharges }) {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" mt={3} px={2}>
      <Box
        component="img"
        borderRadius={3}
        width="100%"
        maxWidth={400}
        minHeight="258px"
        src="/images/empty-additional-charges.webp"
        alt="Empty ancillary charges"
      />
      <Typography mt={4} maxWidth={460} fontWeight={500} align="center">
        {description}
      </Typography>
      <Typography mt={2} maxWidth={460} fontWeight={500} align="center">
        Select the charges that apply, or confirm none.
      </Typography>
      <Box my={3}>
        <Button variant="outlined" startIcon={<AddIcon />} onClick={onAddBillingCharges}>
          Review Charges
        </Button>
      </Box>
    </Box>
  );
}
